export const ALLOWED_DATE_CHARS_REGEX = /^[0-9/\-.]*$/;
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_NUMBER_COUNT = 8; // длина формата DATE_FORMAT
